import { defineMessages } from 'react-intl';

export default defineMessages({
  totalBorrowed: 'Total Borrowed',
  availableLiquidity: 'Available Liquidity',
  utilisationRate: 'Utilisation rate',
});
